import { createAuthClient } from "better-auth/react";

// Use VITE_API_URL for the auth client base URL
// In development, uses localhost API; in production, uses api.tabipla.app
const API_BASE_URL = import.meta.env.VITE_API_URL || "";

export const authClient = createAuthClient({
  baseURL: `${API_BASE_URL}/api/auth`,
});

export const { signIn, signUp, signOut, useSession, changePassword, changeEmail, linkSocial } =
  authClient;
